import { eventEmitter } from '@bnnvara/event-emitter/src/eventEmitter';
import PropTypes from 'prop-types';
import React, { createContext, useEffect } from 'react';

const NPOEventContext = createContext({ emitter: eventEmitter() });

export const NPOEventProvider = ({ children }) => {
  const emitter = eventEmitter();

  useEffect(() => {
    function handleMessage(event) {
      const data = JSON.parse(event.data);
      emitter.emit(data.event, data);
    }

    window.addEventListener('message', handleMessage, false);
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [emitter]);

  return (
    <NPOEventContext.Provider value={{ emitter }}>
      {children}
    </NPOEventContext.Provider>
  );
};

NPOEventProvider.propTypes = {
  children: PropTypes.node,
};

export default NPOEventContext;
